<section class="default-section">
  <article class="default-card">
    <div class="jumbotron mb-3">
      <h1 class="jumbotron-headline">Support</h1>
      <p class="jumbotron-lead">Wenn Sie Hilfe benötigen, kontaktieren Sie mich bitte.</p>
    </div>

    <!-- Contact  -->
    <mat-card>
      <h1 class="paragraph-headline">Email</h1>
      <p>
        Senden Sie eine Email an <a href="mailto:support@aSchwartz.de">support&#64;aSchwartz.de</a> und ich antworte Ihnen schnellstmöglich.
      </p>
    </mat-card>
  </article>
</section>
